var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"statuses"},_vm._l((_vm.statuses),function(status){return _c('span',[_c('span',{staticClass:"status",class:status},[_vm._v(_vm._s(status))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }